/**
 * SmugMug utilities.
 * - Used in the Vue plugin (/app/src/plugins/smugmug.js)
 * - Used in pre-build feed builder (/app/pre-build/build-feeds.js)
 * - Keep dependencies to a minimum since it's used in the app.
 * @type {Object}
 */

module.exports = {
  /**
   * Given a width, return the height of an image
   * @param  {Object} data
   * @param  {Number} width
   * @return {Number}
   */
  getHeight: function (data, width) {
    // return Math.round((data.ratio[1] / data.ratio[0]) * width)
    return data.ratio[1] / data.ratio[0] * width
  },

  /**
   * Resolve a template string for a specific size
   * @param  {Object} data
   * @param  {Number} width
   * @param  {Number} height
   * @return {String}
   */
  resolveTemplate: function (data, width, height) {
    height = height || this.getHeight(data, width)
    return data.template.replace(/#size#/g, `${width}x${height}`)
  },

  /**
   * Build the srcset string
   * @param {Object} data SM image data
   * @param {Object} config SM config from app (don't load in this file)
   * @return {String}
   */
  buildSrcset (data, config) {
    let srcset = ''

    config.image_sizes.forEach((size, index) => {
      srcset += `${this.resolveTemplate(data, size)} ${size}w`
      if (index < config.image_sizes.length - 1) srcset += ', '
    })

    return srcset
  }
}



// WEBPACK FOOTER //
// ./app/lib/smugmug.js